import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import "./serviceDataComponent.css";
import Box from "@mui/material/Box";
import { baseUrl } from "../../../../../../../network/constants/constants";

export const ServiceCardThree = ({ detailservice }) => {
  const { service, price_chart, features } = detailservice;


  const convertToAMPM = (timeString) => {
    const [hour, minute] = timeString.split(":");
    let formattedHour = parseInt(hour, 10);
    const period = formattedHour >= 12 ? "PM" : "AM";
    formattedHour = formattedHour % 12 || 12;
    const formattedMinute = minute.padStart(2, "0");
    return `${formattedHour}:${formattedMinute} ${period}`;
  };

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography variant="h6" sx={{ textAlign: "start", mb: 1.5 }}>
          Features and Service Descriptions
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <div className="key-value">
          <div className="key">Service Name :</div>
          <div className="value">{service?.service}</div>
        </div>
        <div className="key-value">
          <div className="key">Category :</div>
          <div className="value">{service?.category_name}</div>
        </div>

        <div className="key-value">
          <div className="key">Features :</div>
          <div className="value">
            <ul>
              {features.map((feature, index) => (
                <li
                  key={index}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      backgroundColor: feature?.feature_icon,
                      marginRight: 1,
                    }}
                  />
                  {feature?.feature_name}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="key-value">
          <div className="key">Service Description :</div>
          <div className="value">{service?.description}</div>
        </div>

        <Typography variant="h6" sx={{ textAlign: "start", mb: 2, mt: 2 }}>
          Price and Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <div className="key-value">
          <div className="key">Price :</div>
          <div className="value">{price_chart?.price_chart}</div>
        </div>
        <div className="key-value">
          <div className="key">Price Heading :</div>
          <div className="value">{price_chart?.text}</div>
        </div>
        <div className="key-value">
          <div className="key">Price Description :</div>
          <div className="value">{price_chart?.details}</div>
        </div>

        <div className="key-value">
          <div className="key">Starting Time :</div>
          <div className="value">{convertToAMPM(service.open_time)}</div>
        </div>

        <div className="key-value">
          <div className="key">Ending Time :</div>
          <div className="value">{convertToAMPM(service.close_time)}</div>
        </div>

        <div className="key-value">
          <div className="key">Terms and Condition :</div>
          <div className="value">{service?.terms_and_condition}</div>
        </div>
        <Typography variant="h6" sx={{ textAlign: "start", mb: 2, mt: 2 }}>
          Service Thumb
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <div className="service-thumbnail">
          {service.thumb && (
            <img
              src={`${baseUrl}${service?.thumb}`}
              alt={`${service?.service} Thumbnail`}
              style={{
                width: "250px",
                height: "auto",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
};
